// social-link-create.component.ts

import { AfterContentInit, Component, ContentChild, ElementRef } from '@angular/core';
import { SocialLinksService } from '../shared-social-links.service';
import { WebsiteSocialLink } from '../../../portal.model';

@Component({
  selector: 'app-social-link-create',
  templateUrl: './social-link-create.component.html',
  styleUrls: ['./social-link-create.component.css']
})
export class SocialLinkCreateComponent implements AfterContentInit {
  hasCustomTemplate: boolean = false;
  modalOpen = false;
  @ContentChild('customTemplate') public customTemplateRef: ElementRef;
  constructor(private linksService: SocialLinksService) { }


  ngAfterContentInit() {
    this.hasCustomTemplate = !!this.customTemplateRef;
  }

  closeModal(): void {
    this.modalOpen = false;
    
  }

  async handleSave(link: WebsiteSocialLink): Promise<void> {
    await this.linksService.addLink(link);
    this.closeModal();
  }
}
